import { SET_SLOT_BOOKING_REDIRECT_PATH } from './types';

export const setSlotBookingRedirectPath = url => ({
  type: SET_SLOT_BOOKING_REDIRECT_PATH,
  url,
});
